module.exports = {
    base_url:'https://www.sciconf.cn/',
    front_url:'https://mall.sciconf.cn/#/',
    // 语言包
    language:{
        cn:'中文',
        en:'英文',
    },
    // 稿件状态
    abstractStatusList: [
        {
            label: '已完成',
            value: 1
        },
        {
            label: '未完成',
            value: -1
        },
        {
            label: '有投稿未完成',
            value: -3
        },
        {
            label: '无稿件未完成',
            value: -2
        },
        {
            label: '已提交全文附件（中文）',
            value: 2
        },
        {
            label: '未提交全文附件（中文）',
            value: 3
        },
        {
            label: '已提交全文附件（英文）',
            value: 22
        },
        {
            label: '未提交全文附件（英文）',
            value: 33
        },
        {
            label: '已提交全文附件（中英文）',
            value: 222
        },

        {
            label: '未提交全文附件（中英文）',
            value: 333
        },
        {
            label: '已提交PPT（中文）',
            value: 4
        },
        {
            label: '未提交PPT（中文）',
            value: 5
        },

        {
            label: '已提交PPT（英文）',
            value: 44
        },
        {
            label: '未提交PPT（英文）',
            value: 55
        },
        {
            label: '已提交PPT（中英文）',
            value: 444
        },
        {
            label: '未提交PPT（中英文）',
            value: 555
        },
        {
            label: '已提交电子壁报（中文）',
            value: 6
        },
        {
            label: '未提交电子壁报（中文）',
            value: 7
        },
        

        {
            label: '已提交电子壁报（英文）',
            value: 66
        },
        {
            label: '未提交电子壁报（英文）',
            value: 77
        },
        {
            label: '已提交电子壁报（中英文）',
            value: 666
        },
        {
            label: '未提交电子壁报（中英文）',
            value: 777
        },
        {
            label: '已提交摘要（中文）',
            value: 8
        },
        {
            label: '未提交摘要（中文）',
            value: 9
        },

        {
            label: '已提交摘要（英文）',
            value: 88
        },
        {
            label: '未提交摘要（英文）',
            value: 99
        },
        {
            label: '已提交摘要（中英文）',
            value: 888
        },
        {
            label: '未提交摘要（中英文）',
            value: 999
        },
        {
            label: '已提交视频（中文）',
            value: 10
        },
        {
            label: '未提交视频（中文）',
            value: 11
        },
        {
            label: '已提交视频（英文）',
            value: 1010
        },
        {
            label: '未提交视频（英文）',
            value: 1111
        },
        {
            label: '已提交视频（中英文）',
            value: 101010
        },
        {
            label: '未提交视频（中英文）',
            value: 111111
        },
    ],
    // 学分类型枚举
    credit_type:[
        {id:1,title:'I类学分'},
        {id:2,title:'II类学分'},
        {id:3,title:'I类/II类学分'},
        {id:0,title:'无'},
    ],

    // 表单类型
    form_type:[
        {
            icon:"med-wenben",
            name:"普通文本框",
            type:'text',
        },
        {
            icon:"med-iocnwenben",
            name:"多行文本框",
            type:'textarea',
        },
        {
            icon:"med-danxuanti",
            name:"单选框",
            type:'radio',
        },
        {
            icon:"med-muti-selector",
            name:"多选框",
            type:'checkbox',
        },
        {
            icon:"med-select",
            name:"下拉选择框",
            type:'select',
        },
        {
            icon:"med-rili",
            name:"日历",
            type:'date',
        },
        {
            icon:"med-shangchuan",
            name:"上传文件",
            type:'file',
        },
    ],

    channel_form_type_list: [
        {
            icon:"med-wenben",
            name:"普通文本框",
            type:'text',
        },
        {
            icon:"med-iocnwenben",
            name:"多行文本框",
            type:'textarea',
        },
        {
            icon:"med-danxuanti",
            name:"单选框",
            type:'radio',
        },
        {
            icon:"med-muti-selector",
            name:"多选框",
            type:'checkbox',
        },
        {
            icon:"med-select",
            name:"下拉选择框",
            type:'select',
        },
        {
            icon:"med-shangchuan",
            name:"上传文件",
            type:'file'
        },
        // {
        //     icon:"med-rili",
        //     name:"日历",
        //     type:'date',
        // },
        // {
        //     icon:"med-wenben",
        //     name:"评奖配置",
        //     type:'awards'
        // }
    ],

    // 日程网站显示方式
    display_mode:[
        {value:'0',label:'默认'},
        {value:'1',label:'英文'},
        {value:'2',label:'中英文'},
        {value:'3',label:'中文'},
        {value:"-1",label:'不显示'},
    ],

    // 币种
    currencyType:{
        1:'人民币',
        2:'美元',
        3:'欧元',
        4:'香港元',
        5:'澳门元',
    },

    // 直播来源
    live_source:[
        {value:'0',label:'默认会场配置'},
        {value:'1',label:'系统表直播'},
        {value:'2',label:'第三方平台直播'},
        {value:'3',label:'暂无直播'},
    ]
}
